import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=7d7dbbab&scoped=true&"
import script from "./ProductTitle.vue?vue&type=script&lang=js&"
export * from "./ProductTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7dbbab",
  null
  
)

export default component.exports